const spinnerWheelActions = {
  'SPINNER_WHEEL/SHOW_SPINNING_WHEEL': () => {},
  'SPINNER_WHEEL/TICK': () => {},
  'SPINNER_WHEEL/SPINNING_WHEEL_RESULT': () => {},
  'SPINNER_WHEEL/DESTROY': () => {},
}

export default spinnerWheelActions
